/**
 * Admin formatting utilities.
 * Pure functions — no side effects, no env access.
 */

/** Format ISO date string to compact Dutch date */
export function formatDate(iso) {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleDateString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    })
  } catch {
    return iso
  }
}

/** Format ISO date string to Dutch date + time */
export function formatDateTime(iso) {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('nl-NL', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return iso
  }
}

/** Format milliseconds to human-readable duration */
export function formatDuration(ms) {
  if (ms == null) return '—'
  if (ms < 1000) return `${ms}ms`
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`
  return `${Math.round(ms / 60000)}m`
}

/** Format duration from two ISO date strings */
export function formatDurationBetween(startIso, endIso) {
  if (!startIso || !endIso) return '—'
  const ms = new Date(endIso) - new Date(startIso)
  return formatDuration(ms)
}

/** Format a number with locale-aware thousands separators */
export function formatCount(n) {
  if (n == null) return '—'
  return n.toLocaleString('nl-NL')
}

/** Format a percentage (already computed as a number) */
export function formatPercent(value, decimals = 0) {
  if (value == null) return '—'
  return `${value.toFixed(decimals)}%`
}

/** Compute acceptance rate from extracted and accepted counts */
export function computeAcceptRate(extracted, accepted) {
  if (!extracted || extracted === 0) return null
  return Math.round((accepted / extracted) * 100)
}
